import React from 'react';

/** SEF Step 2 maturity benchmarks: hover to preview, pin to keep open while writing narrative. */
export function LevelMaturityTooltip({
  num,
  gridLevel,
  gridLabels,
  tipOpen,
  isPinned,
  pinLabel,
  unpinLabel,
  pinHint,
  onHoverEnter,
  onPin,
  onClose,
}) {
  return (
    <div
      role="dialog"
      aria-hidden={!tipOpen}
      className={`level-tooltip ${tipOpen ? 'level-tooltip--visible' : ''} ${isPinned ? 'level-tooltip--pinned' : ''}`}
      onMouseEnter={onHoverEnter}
    >
      <div className="level-tooltip__toolbar">
        {isPinned ? (
          <>
            <span className="level-tooltip__pinned-label">{pinHint}</span>
            <button
              type="button"
              className="level-tooltip__btn level-tooltip__btn--close"
              aria-label={unpinLabel}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              ×
            </button>
          </>
        ) : tipOpen ? (
          <button
            type="button"
            className="level-tooltip__btn level-tooltip__btn--pin"
            aria-label={pinLabel}
            onClick={(e) => {
              e.stopPropagation();
              onPin(num);
            }}
          >
            {pinLabel}
          </button>
        ) : null}
      </div>
      <h4 className="level-tooltip__title">{gridLevel.label}</h4>
      <div className="level-tooltip__body">
        {Object.entries(gridLevel).map(([key, val]) =>
          key !== 'label' ? (
            <div key={key} className="level-tooltip__row">
              <strong>{gridLabels && gridLabels[key] ? gridLabels[key] : key}:</strong>
              <span>{val}</span>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
}
